import React from 'react';
import { Download, Trash2, X } from 'lucide-react';

import { LoadingSpinner } from '../../../components/LoadingSpinner';

type LeadBulkActionBarProps = {
  selectedCount: number;
  onClear: () => void;
  onExport: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
};

/** Erscheint erst bei aktiver Auswahl — sonst kostet die Leiste dauerhaft Platz. */
export function LeadBulkActionBar({
  selectedCount,
  onClear,
  onExport,
  onDelete,
  isDeleting = false,
}: LeadBulkActionBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-6 z-20 hidden justify-center px-4 md:flex">
      <div className="pointer-events-auto flex items-center gap-2 rounded-lg bg-slate-900 py-2 pl-4 pr-2 text-white shadow-lg">
        <span className="text-sm font-medium tabular-nums">
          {selectedCount} {selectedCount === 1 ? 'Projekt' : 'Projekte'} ausgewählt
        </span>
        <div className="mx-1 h-5 w-px bg-white/20" />
        <button
          type="button"
          onClick={onExport}
          disabled={isDeleting}
          className="inline-flex h-9 items-center gap-2 rounded-md px-3 text-sm font-medium text-slate-100 transition-colors hover:bg-white/10 disabled:opacity-40"
        >
          <Download className="h-4 w-4" />
          CSV exportieren
        </button>
        <button
          type="button"
          onClick={onDelete}
          disabled={isDeleting}
          className="inline-flex h-9 items-center gap-2 rounded-md px-3 text-sm font-medium text-rose-300 transition-colors hover:bg-rose-500/15 disabled:opacity-40"
        >
          {isDeleting ? <LoadingSpinner /> : <Trash2 className="h-4 w-4" />}
          Löschen
        </button>
        <button
          type="button"
          onClick={onClear}
          disabled={isDeleting}
          className="ml-1 rounded-md p-2 text-slate-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-40"
          aria-label="Auswahl aufheben"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
